import { useOktaAuth } from '@okta/okta-react'
import React, { useEffect, useState } from 'react'
import ScbmSurvey from './ScbmSurveyPage';
import ScbmIndirect from '../scbm-indirect/ScbmIndirectSurveyPage';
import { getSurveyResponse, getSurveyById, getAllCountryList, getAvailableLanguages, getSurveyLiterals } from '../../services/survey.service';
import { useDispatch } from 'react-redux';
import { setSurveyResponse, updateUserInfo } from '../../redux/action/surveyAction';
import { getCampaigsByRn } from '../../services/campaign.service';
import { setCampaign } from '../../redux/action/campaignAction'
import { Redirect } from 'react-router-dom';
import { CRS_REQUEST_STATUS_OBJ, SCBM_USER_TYPE, SCBM_STATES_CAMPAIGN, SCBM_CODE, SCBM_INDIRECT, EMPTY_BODY, CODE_SURVEY_LANGUAGE } from '../../utils/surveyLiterals';
import { useUserInfo } from '../../providers/userProvider'
import queryString from 'query-string'
import { ERR_DESC_REQUEST_NUMBER, ERR_DESC_SURVEY_CODE, ERR_TITLE_REQUEST_NUMBER, ERR_TITLE_SURVEY_CODE } from '../../utils/errorLiterals';

function validationRules(respCampaign, userInfo) {
    let error;
    if (respCampaign) {
        if (userInfo.userType !== SCBM_USER_TYPE.SALARY) {
            //it is normal user, we have to validate that the current user has the supplier
            if (!userInfo.suppliers || userInfo.suppliers.length <= 0
                || !userInfo.suppliers.includes(respCampaign.assignments[0].supplierNumber)) {
                error = 'No suppliers assigned';
            }//else everything is OK
        }//else Read only for the deere employee
    } else {//The assignment does not exist
        error = 'No campaing found';
    }
    return error;
}

function isValidRN(rn) {
    return rn && rn.length <= 19 && !isNaN(rn) && Number.isInteger(parseFloat(rn));//Size in DB
}

function sentToReview(campaignAssigned, userInfo) {
    return campaignAssigned.assignments[0].status === CRS_REQUEST_STATUS_OBJ.COMPLETE ||
        campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED || userInfo.userType === SCBM_USER_TYPE.SALARY
}

export default function Home({ ...props }) {
    const actualURL = window.location.href;
    const { authState } = useOktaAuth();
    const userInfo = useUserInfo();
    const [survey, setSurvey] = useState(undefined);
    const [containsError, setContainsError] = useState(false);
    const [campaignAssigned, setCampaignAssigned] = useState();
    const dispatch = useDispatch();
    const [surveyResponseHome, setSurveyResponseHome] = useState(undefined);
    const[countryList, setCountryList]= useState(undefined);  
    const [surveyLanguages, setSurveyLanguages] = useState([]);

    let value = queryString.parse(props.location.search);
    const rn = value.rn;

    //Remove user info from redux
    if (userInfo) {
        dispatch(updateUserInfo(userInfo));
    }

    useEffect(() => {
        if (userInfo && rn && !campaignAssigned && isValidRN(rn)) {
            getCampaigsByRn(rn, authState.accessToken.accessToken)
                .then((res) => {
                    let errorValidation = validationRules(res, userInfo);
                    if (errorValidation) {
                        setContainsError(true)
                    } else {
                        setCampaignAssigned(res);
                        dispatch(setCampaign(res));
                    }
                }).catch(error => {
                    //Campaign not found
                    setContainsError(true)
                })
        }
    }, [userInfo, campaignAssigned]);

    useEffect(() => {
        if (!survey && campaignAssigned && !containsError) {
            getSurveyById(campaignAssigned.surveyId, authState.accessToken.accessToken)
                .then((s) => {
                    setSurvey(s);
                })
        }
    }, [survey, campaignAssigned])

    useEffect(()=>{    
        if(!countryList){
            getAllCountryList(authState.accessToken.accessToken).then(response => {
               if(response){
                 setCountryList(response);
                }
            })
        } 
      
    },[]);

    useEffect(async () => {
        if (survey && !containsError) {
            const languageList = await getAvailableLanguages(authState.accessToken.accessToken);
            const literals = await getSurveyLiterals(survey.id, null, authState.accessToken.accessToken);
            const languages = [];
            literals.forEach((lt) => {
                if(lt.code.toLowerCase() === `${survey.code.toLowerCase()}_${CODE_SURVEY_LANGUAGE}`) {
                    const index = languageList.findIndex((item) => item.languageCd === lt.languageCd);
                    if(index > -1)  languages.push({code: lt.languageCd, name: lt.text, country_code: languageList[index].countryCode});
                }
            });
            setSurveyLanguages(languages);
        }
      }, [survey]);


    useEffect(() => {
        if (campaignAssigned && userInfo && !containsError && !surveyResponseHome) {
            getSurveyResponse(campaignAssigned, userInfo, authState.accessToken.accessToken)
                .then((res) => {
                    dispatch(setSurveyResponse(res));
                    setSurveyResponseHome(res);
                }).catch(error => {
                    console.log(error);
                    setSurveyResponseHome([]);
                })
        }
    }, [campaignAssigned, userInfo, dispatch, surveyResponseHome]);

    if (!rn || containsError || !isValidRN(rn)) {
        return <Redirect
                to={{    
                pathname: '/error',
                state: {errorTitle: ERR_TITLE_REQUEST_NUMBER,
                        errorDescription: ERR_DESC_REQUEST_NUMBER, 
                        errorUrl:actualURL,
                        errorUser: userInfo? userInfo.userID : ''}
                }}
            />
    }

    if (!userInfo || !survey) {
        return (EMPTY_BODY)
    }
    else {
        if (!userInfo || !campaignAssigned || !survey) {
            return (EMPTY_BODY)
        } else {
            if (sentToReview(campaignAssigned, userInfo)) {
                return <Redirect to={{
                    pathname: '/review',
                    state: {
                        previous: '/scbm',
                        survey: survey,
                        updatedByName: props.location && props.location.state ? props.location.state.updatedByName : '',
                        updatedTs: props.location && props.location.state ? props.location.state.updatedTs : '',
                        status:  campaignAssigned.assignments[0].status,
                        supplierName: campaignAssigned.assignments[0].supplierName,
                        surveyType: survey.description,
                        campaign:campaignAssigned
                    }
                }} />
            } else {
                switch(survey.code){
                    case SCBM_CODE:
                        return <ScbmSurvey survey={survey} setSurvey={setSurvey} countryList={countryList} surveyLanguages={surveyLanguages}/>
                    case SCBM_INDIRECT:
                        return <ScbmIndirect survey={survey} setSurvey={setSurvey} surveyLanguages={surveyLanguages}/>
                    default:
                        return <Redirect
                                    to={{
                                    pathname: '/error',
                                    state: {errorTitle: ERR_TITLE_SURVEY_CODE,
                                            errorDescription: ERR_DESC_SURVEY_CODE, 
                                            errorUrl:actualURL,
                                            errorUser: userInfo? userInfo.userID : ''}
                                    }}
                                />
                }
            }

        }

    }
}